import React from 'react';
import { useDispatch } from 'react-redux';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import Zone from '@wix/da-gruser-shared/pkg/components/Zone';
import GruserContext from '@wix/da-gruser-shared/pkg/context/GruserContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import ExhibitionistBox from '../../../widgets/Exhibitionist/ExhibitionistBox';
import ExhibitionistConfigPopoverLazy from '../../../widgets/Exhibitionist/ExhibitionistConfigPopover/ExhibitionistConfigPopoverLazy';
import SubmissionDetails from '../../../SubmissionDetails';
import { getGruserForDeviation, isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import defaultRemoveConfirmation from '../../../widgets/defaultRemoveConfirmation';
import ExtendedDetails from './ExtendedDetails';
import s from './Default.scss';
export const DefaultDetails = ({ deviation, className, contentClassName })=>{
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    const deviation_gruser_flag = useFlag('deviation_gruser');
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className, contentClassName)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['title-block'],
        "data-hook": BiDataHook.DEVIATION_META
    }, /*#__PURE__*/ React.createElement(SubmissionDetails, {
        deviation: deviation,
        showTitle: true
    })), isExtendedLoaded && /*#__PURE__*/ React.createElement(ExtendedDetails, {
        deviation: deviation
    }), deviation_gruser_flag && /*#__PURE__*/ React.createElement(GruserContext.Provider, {
        value: getGruserForDeviation(deviation)
    }, /*#__PURE__*/ React.createElement(Zone, {
        name: "local",
        withStaticAddWidget: true,
        mapModuleTypeToWidgetConfig: {
            exhibitionist: {
                viewComponent: ExhibitionistBox,
                configPopoverComponent: ExhibitionistConfigPopoverLazy,
                confirmRemove: defaultRemoveConfirmation({
                    t,
                    dispatch
                }),
                widgetCard: {
                    minuatureImageSrc: 'https://st.deviantart.net/eclipse/widgets/miniatures/2022/il8-3-carousel-gallery.svg',
                    title: t('widgets.exhibitionist.scroller.addButtonHeader'),
                    description: t('widgets.exhibitionist.scroller.description')
                }
            }
        }
    })));
};
DefaultDetails.displayName = 'DefaultDetails';
export default DefaultDetails;
